import client from "api/client";

// F1 — contentManagementApi. The full-content endpoints write the type-specific
// block, categories, tags and media in one transaction. Use these for
// create/edit; use contentApi only for lifecycle actions and listing.
//
// All routes are website-scoped — the website comes from the path, so
// `website_id` is omitted from request bodies.

// POST .../content/full responds 201 { content_id, message }.
export const createFullContent = async (websiteId, typeSlug, payload) => {
  const { data } = await client.post(
    `/websites/${websiteId}/content-management/${typeSlug}/content/full`,
    payload
  );
  return data;
};

export const updateFullContent = async (websiteId, typeSlug, id, payload) => {
  const { data } = await client.put(
    `/websites/${websiteId}/content-management/${typeSlug}/content/${id}/full`,
    payload
  );
  return data;
};

// GET .../content/{id}/full → FullContentResponse — base content + raw editor
// IDs (author_id, featured_image_id, category_ids, tag_ids, media_relations[])
// plus the matching type block. One call hydrates the whole edit form.
export const getFullContent = async (websiteId, typeSlug, id) => {
  const { data } = await client.get(
    `/websites/${websiteId}/content-management/${typeSlug}/content/${id}/full`
  );
  return data;
};
